import { useState } from "react";
import { Phone, Menu, X } from "lucide-react";
import { Logo } from "./Logo";

const LINKS = [
  { label: "Services", href: "#services", testid: "nav-link-services" },
  { label: "Coverage", href: "#coverage", testid: "nav-link-coverage" },
  { label: "Before & After", href: "#gallery", testid: "nav-link-gallery" },
  { label: "Process", href: "#process", testid: "nav-link-process" },
  { label: "Reviews", href: "#testimonials", testid: "nav-link-testimonials" },
  { label: "Refer & Earn", href: "#referrals", testid: "nav-link-referrals" },
];

export const Nav = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="fixed inset-x-0 top-0 z-50 px-3 pt-3 sm:px-6" data-testid="site-header">
      <div className="mx-auto flex max-w-7xl items-center justify-between rounded-full border border-white/10 bg-slate-950/85 py-2.5 pl-4 pr-3 shadow-[0_8px_40px_-12px_rgba(0,0,0,0.7)] backdrop-blur-xl sm:pl-5">
        <a href="#top" className="flex items-center gap-3" data-testid="nav-logo">
          <Logo className="h-9 w-9" />
          <span className="font-display text-base font-bold uppercase leading-none tracking-wide text-slate-100 sm:text-lg">
            D&amp;G Home Solutions
            <span className="block text-[10px] font-semibold tracking-[0.2em] text-orange-500">
              Gutters &amp; Waterproofing
            </span>
          </span>
        </a>
        <nav className="hidden items-center gap-7 lg:flex">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.testid}
              className="nav-link text-sm font-medium text-slate-300 transition-colors hover:text-orange-500"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="hidden items-center gap-3 lg:flex">
          <a
            href="tel:+19089567550"
            data-testid="nav-phone-button"
            className="flex items-center gap-2 rounded-full border border-white/15 px-4 py-2 text-sm font-semibold text-slate-200 transition-colors hover:border-orange-500/50 hover:text-orange-500"
          >
            <Phone className="h-4 w-4" /> (908) 956-7550
          </a>
          <a
            href="#quote"
            data-testid="nav-quote-button"
            className="animate-pulse-ring rounded-full bg-orange-500 px-5 py-2 text-sm font-bold text-ink transition-colors hover:bg-orange-600 hover:text-white"
          >
            Get Free Quote
          </a>
        </div>
        <button
          className="text-slate-200 lg:hidden"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>
      {open && (
        <div className="mx-auto mt-2 max-w-7xl rounded-2xl border border-white/10 bg-slate-950/95 px-6 py-4 backdrop-blur-xl lg:hidden" data-testid="nav-mobile-menu">
          <div className="flex flex-col gap-4">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-base font-medium text-slate-200"
                data-testid={`${l.testid}-mobile`}
              >
                {l.label}
              </a>
            ))}
            <a
              href="#quote"
              onClick={() => setOpen(false)}
              className="rounded-full bg-orange-500 px-5 py-3 text-center text-sm font-bold text-ink"
              data-testid="nav-quote-button-mobile"
            >
              Get Free Quote
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
